import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap'
import 'bootstrap/dist/js/bootstrap.min.js'
import './assets/scss/app.scss'
import VueFeather from 'vue-feather'
import Breadcrumbs from './layout/breadCrumbs.vue'
import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'
import '@vuepic/vue-datepicker/dist/main.css'
import Datepicker from '@vuepic/vue-datepicker'

import { createI18n } from 'vue-i18n'
import English from './locales/en.json'
import لعربية from './locales/ae.json'
import 简体中文 from './locales/cn.json'
import Português from './locales/pt.json'
import Français from './locales/fr.json'
import Deutsch from './locales/de.json'
import Español from './locales/es.json'
const i18n = createI18n({
  legacy: false,
  locale: 'Español',
  fallbackLocale: 'Español',
  messages: {
    English: English,
    Español: Español,
    Deutsch: Deutsch,
    Français: Français,
    Português: Português,
    简体中文: 简体中文,
    لعربية: لعربية,
  },
})

createApp(App)
  .use(store)
  .use(router)
  .use(i18n)
  .use(VueSweetalert2)
  .component(VueFeather.name, VueFeather)
  .component('Breadcrumbs', Breadcrumbs)
  .component('Datepicker', Datepicker)
  .mount('#app')
